import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { LandingPage } from './LandingPage'
import { GuidePage } from './GuidePage'
import { MerchantAuditPage } from './MerchantAuditPage'
import { MerchantGuidePage } from './MerchantGuidePage'
import { WooCommercePluginPage } from './WooCommercePluginPage'
import { SaasDashboardPage } from './SaasDashboardPage'
import { getLegalKind, LegalPage } from './LegalPage'
import './styles.css'

const legalKind = getLegalKind(window.location.pathname)
const isDemo = window.location.pathname.replace(/\/$/, '') === '/demo'
const isGuide = window.location.pathname.replace(/\/$/, '') === '/guides/validate-woocommerce-product-csv'
const isMerchantAudit = window.location.pathname.replace(/\/$/, '') === '/merchant-audit'
const isMerchantGuide = window.location.pathname.replace(/\/$/, '') === '/guides/google-merchant-center-feed-errors'
const isWooCommercePlugin = window.location.pathname.replace(/\/$/, '') === '/woocommerce-plugin'
const isDashboard = window.location.pathname.replace(/\/$/, '').startsWith('/dashboard')

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {legalKind ? <LegalPage kind={legalKind} /> : isDashboard ? <SaasDashboardPage /> : isDemo ? <App /> : isGuide ? <GuidePage /> : isMerchantAudit ? <MerchantAuditPage /> : isMerchantGuide ? <MerchantGuidePage /> : isWooCommercePlugin ? <WooCommercePluginPage /> : <LandingPage />}
  </StrictMode>,
)
